/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GescalesRawDataProgress } from '../../models/gescales-raw-data-progress';

export interface GetGescalesRawDataProcessProgress$Params {
}

export function getGescalesRawDataProcessProgress(http: HttpClient, rootUrl: string, params?: GetGescalesRawDataProcessProgress$Params, context?: HttpContext): Observable<StrictHttpResponse<GescalesRawDataProgress>> {
  const rb = new RequestBuilder(rootUrl, getGescalesRawDataProcessProgress.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GescalesRawDataProgress>;
    })
  );
}

getGescalesRawDataProcessProgress.PATH = '/custom/dock-occupancy/gescales/progress-state';
